import SliderTrainings from './SliderTrainings'

export default SliderTrainings
